import { listTags } from '@platform/client';

/**
 * The tag vocabulary, for a picker to offer before a reviewer invents one — 016 §4.
 *
 * Its own key rather than under a screen's prefix: the table is shared by every surface
 * that edits labels, and a lesson gaining a tag does not change what the other lessons
 * may be labelled with. Adding a tag invalidates this key, which is the one write that
 * does change it.
 */
export const tagsQuery = () => ({
  queryKey: ['tags'],
  queryFn: () => listTags({ throwOnError: true }),
});
